module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_manage.b3a54b26.svg";